type IgnoreZoneLike = {
  label_display_name?: string | null;
};

const IGNORE_MOTION_LABEL = "ignore motion";
const CAMERA_HEALTH_MONITORING_LABEL = "camera health monitoring";

export const isChmOnlyIgnoreZones = (zones: IgnoreZoneLike[]): boolean => {
  if (!Array.isArray(zones) || zones.length !== 2) {
    return false;
  }

  const labels = zones
    .map((zone) => (zone?.label_display_name || "").trim().toLowerCase())
    .filter((label) => label.length > 0);

  if (labels.length !== 2) {
    return false;
  }

  const uniqueLabels = new Set(labels);

  return (
    uniqueLabels.size === 2 &&
    uniqueLabels.has(IGNORE_MOTION_LABEL) &&
    uniqueLabels.has(CAMERA_HEALTH_MONITORING_LABEL)
  );
};
